export const EMPTY_PAGE = {
  content: undefined,
  hero: undefined,
  meta_data: undefined,
  linked_pages: undefined,
  global_footer: undefined,
  noindex_this_page: undefined,
  is_pest_library_parent_page: undefined,
  is_gallery_parent_page: undefined,
  alternating_content: undefined,
  legacy_navigation_grid_alternate_background: undefined,
  custom_tracking_number: undefined,
}
